import PaymentFailedComponent from "../Components/PaymentFailed";

const PaymentFailed = () => {
  return <PaymentFailedComponent />;
};
export default PaymentFailed;
